<template>
  <card-form
    :collapsed="!isToggleCollapsed"
    class="comunication-edit"
  >
    <div
      slot="expanded"
      class="form-container"
    >
      <span class="comunication-edit-mandatory">* Preenchimento obrigatório</span>
      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout
          md-flex="40"
          md-flex-medium="40"
          class="inputidlab"
        >
          <md-input-container
            id="txtTitleEditContainer"
            :class="{'md-input-invalid': errors.has('txtTitleEdit')}"
          >
            <label>Título do Aviso *</label>
            <md-input
              id="txtTitleEdit"
              v-model="notificationEdit.title"
              v-validate="'required'"
              data-vv-validate-on="none"
              name="txtTitleEdit"
              maxlength="250"
              type="text"
              title
              placeholder="Título do Aviso *"
              @keyup.enter.native="validateBeforeSubmit()"
              @keydown.enter.native="focusNextField('txtLinkEdit')"
            />
            <span class="md-error">Obrigatório</span>
          </md-input-container>
        </md-layout>

        <md-layout
          md-flex="40"
          md-flex-medium="40"
          class="inputidlab"
        >
          <md-input-container
            id="txtLinkEditContainer"
            :class="{'md-input-invalid': errors.has('txtLinkEdit')}"
          >
            <label>Link</label>
            <md-input
              id="txtLinkEdit"
              v-model="notificationEdit.link"
              v-validate="'url:require_protocol'"
              data-vv-validate-on="none"
              name="txtLinkEdit"
              type="text"
              title
              placeholder="Link"
              @keyup.enter.native="validateBeforeSubmit()"
              @keydown.enter.native="focusNextField('txtMessageEdit')"
            />
            <span
              v-if="errors.firstByRule('txtLinkEdit','url')"
              class="md-error"
            >URL inválida</span>
          </md-input-container>
        </md-layout>
      </md-layout>

      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout md-flex="25">
          <md-input-container
            id="dtStartEditContainer"
            :class="{'md-input-invalid': errors.has('dtStartEdit')}"
          >
            <label>Data de inicial *</label>
            <md-input
              id="dtStartEdit"
              v-model="notificationEdit.startDate"
              v-mask="'##/##/####'"
              v-validate="'required|check_date_format:DD/MM/YYYY'"
              maxlength="10"
              type="text"
              placeholder="Data inicial *"
              data-vv-validate-on="none"
              title
              name="dtStartEdit"
            />
            <span
              v-if="errors.firstByRule('dtStartEdit','required')"
              class="md-error"
            >Obrigatório</span>
            <span
              v-else-if="errors.firstByRule('dtStartEdit','check_date_format')"
              class="md-error"
            >Valor inválido</span>
          </md-input-container>
        </md-layout>

        <md-layout md-flex="25">
          <md-input-container
            id="dtFinalEditContainer"
            :class="{'md-input-invalid': errors.has('dtFinalEdit')}"
          >
            <label>Data final *</label>
            <md-input
              id="dtFinalEdit"
              v-model="notificationEdit.endDate"
              v-mask="'##/##/####'"
              v-validate="'required|check_date_format:DD/MM/YYYY'"
              maxlength="10"
              type="text"
              placeholder="Data final *"
              data-vv-validate-on="none"
              title
              name="dtFinalEdit"
            />
            <span
              v-if="errors.firstByRule('dtFinalEdit','required')"
              class="md-error"
            >Obrigatório</span>
            <span
              v-else-if="errors.firstByRule('dtFinalEdit','check_date_format')"
              class="md-error"
            >Valor inválido</span>
          </md-input-container>
        </md-layout>

        <md-layout md-flex="25">
          <md-input-container
            id="cboNotificationTypeEdit"
            :class="{'md-input-invalid': errors.has('cboType')}"
          >
            <label>Tipo da Notificação *</label>
            <advanced-select
              id="cboType"
              v-model="notificationEdit.type"
              v-validate="'required'"
              :options="typesOptions"
              placeholder="Selecione uma opção"
              name="cboType"
              data-vv-validate-on="none"
              title
            />
            <span
              v-if="errors.firstByRule('dtStart','required')"
              class="md-error"
            >Obrigatório</span>
          </md-input-container>
        </md-layout>

        <md-layout md-flex="15">
          <md-switch
            id="notificationEdit"
            v-model="notificationEdit.enabled"
            name="Status"
            class="md-primary"
          >
            Habilitado
          </md-switch>
        </md-layout>
      </md-layout>
      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout
          md-flex="40"
          class="radio__container"
        >
          <p>Enviar para:</p>
          <md-radio
            v-model="notificationEdit.sendAll"
            :md-value="true"
          >
            Todos
          </md-radio>
          <md-radio
            v-model="notificationEdit.sendAll"
            :md-value="false"
          >
            Especificar destinatários
          </md-radio>
        </md-layout>
        <md-layout md-flex="55">
          <md-input-container
            id="txtLabIdsContainer"
            :class="{'md-input-invalid': errors.has('txtLabIds')}"
          >
            <label
              v-if="!notificationEdit.sendAll"
            >Digite os IDs dos destinatários separados por vírgula *</label>
            <md-input
              id="txtLabIds"
              v-model="notificationEdit.ids"
              v-validate="'required'"
              :disabled="notificationEdit.sendAll"
              data-vv-validate-on="none"
              name="txtLabIds"
              type="text"
              @keyup.enter.native="validateBeforeSubmit()"
            />
            <span class="md-error">Obrigatório</span>
          </md-input-container>
        </md-layout>
      </md-layout>

      <md-layout
        :md-gutter="24"
        md-flex="100"
      >
        <md-layout
          md-flex="80"
          md-flex-medium="40"
          class="inputidlab"
        >
          <md-input-container
            id="txtMessageEditContainer"
            :class="{'md-input-invalid': errors.has('txtMessageEdit')}"
          >
            <label>Mensagem *</label>
            <md-textarea
              id="txtMessageEdit"
              v-model="notificationEdit.message"
              v-validate="'required'"
              md-autogrow="true"
              data-vv-validate-on="none"
              name="txtMessageEdit"
              maxlength="200"
              type="text"
              title
              placeholder="Mensagem *"
              @keyup.enter.native="validateBeforeSubmit()"
              @keydown.enter.native="focusNextField('dtStartEdit')"
            />
            <span class="md-error">Obrigatório</span>
          </md-input-container>
        </md-layout>

        <md-layout md-flex="20">
          <md-button
            id="btnAdminSubmitFeature"
            class="btn btn-primary comunication-edit__patient__submit-button submit-button"
            @click="validateBeforeSubmit"
          >
            ATUALIZAR
          </md-button>
        </md-layout>
      </md-layout>
    </div>
  </card-form>
</template>

<script>
import AdvancedSelect from '@/components/common/AdvancedSelect'
import { mapActions, mapGetters } from 'vuex'
import CardForm from '@/components/common/CardForm'
import { mask } from 'vue-the-mask'
import { scrollToElement } from '@/utils/window-utils'
import comunicationService from '@/api/comunication'
import notify from '@/api/notification'
import strings from '@/strings'

const NOTIFICATION_DEFAULT = {
  title: '',
  message: '',
  link: '',
  enabled: true,
  read: null,
  type: null,
  sendAll: true,
  ids: ''
}

export default {
  name: 'ComunicationEdit',
  components: {
    'advanced-select': AdvancedSelect,
    'card-form': CardForm
  },
  directives: {
    mask: mask
  },
  props: ['alertForEdition', 'isModalOpen', 'closeEditAlert'],
  data: () => {
    return {
      laboratoryID: '',
      featureModel: '',
      optionModel: '',
      isToggleCollapsed: false,
      loadingData: false,
      notificationEdit: NOTIFICATION_DEFAULT,
      startHour: ' 00:00:00',
      endTime: ' 23:59:59',
      typesOptions: strings.notificationTypes
    }
  },
  methods: {
    ...mapActions(['setToggle']),
    focusNextField (id) {
      document.getElementById(id).focus()
    },
    validateBeforeSubmit (evt) {
      // Abort if user pressed enter + shift
      if (evt && evt.keyCode === 13 && evt.shiftKey) {
        return
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateNotification()
          return
        } else {
          this.analyticsForValidationErrors()
        }

        if (this.errors.items.length) {
          let elementName = this.errors.items[0].field
          let element = ''
          element = document.querySelector('[name="' + elementName + '"]')
          scrollToElement(element)
          element.focus()
        }
      })
    },
    analyticsForValidationErrors () {
      let self = this
      this.errors.all().forEach(function (errorMessage) {
        self.$analytics.pushAnalyticsEvent('error-validation', {
          'msg-error': errorMessage
        })
      })
    },
    preventRawEnterFromPropagation (event) {
      if (
        !event.altKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.metaKey
      ) {
        // Enter without any modifier
        event.preventDefault()
      }
    },
    formatNotificationToSave () {
      let notification = this.notificationEdit
      let startDateReverted = this.setDateFormat(notification.startDate)
      let endDateReverted = this.setDateFormat(notification.endDate)

      notification['start-date'] = startDateReverted + this.startHour
      notification['end-date'] = endDateReverted + this.endTime
      notification.type = this.notificationEdit.type.value
      notification['id-notification'] = this.notificationEdit.idNotification
      notification['id-laboratory'] = this.notificationEdit.idLaboratory
      if (!notification.sendAll) {
        notification.ids = this.notificationEdit.ids.split(',')
      } else {
        notification.ids = []
      }

      return notification
    },
    clearPageData () {
      this.notificationEdit = NOTIFICATION_DEFAULT
      window.scrollTo(0, 0)
    },
    updateNotification () {
      let notification = this.formatNotificationToSave()

      comunicationService.updateNotification(notification).then(response => {
        if (response) {
          this.clearPageData()
          this.closeEditAlert()
          let sucessMsg = 'Notificação atualizada com sucesso.'
          notify({
            title: 'AVISO:',
            message: sucessMsg
          })
        }
      })
    },
    setDateFormat (date) {
      let dateReversed = date
        .split('/')
        .reverse()
        .join('/')
      return dateReversed.split('/').join('-')
    },
    loadOrderForEdit () {
      this.notificationEdit = {
        idNotification: this.alertForEdition['id-notification'],
        title: this.alertForEdition.title,
        message: this.alertForEdition.message,
        startDate: this.reformatDate(this.alertForEdition['start-date']),
        endDate: this.reformatDate(this.alertForEdition['end-date']),
        link: this.alertForEdition.link,
        idLaboratory: this.alertForEdition['id-laboratory'],
        enabled: this.alertForEdition.enabled,
        readDate: this.alertForEdition['read-date'],
        read: this.alertForEdition.read,
        type: this.typesOptions.filter(
          options => options.value === this.alertForEdition.type
        )[0],
        sendAll: this.alertForEdition.sendAll,
        ids: this.alertForEdition.ids.length > 0 ? this.alertForEdition.ids.join(', ') : ''
      }
      if (this.alertForEdition['read-date'] !== null) {
        this.notificationEdit.readDate = this.reformatDate(
          this.alertForEdition['read-date']
        )
      }
    },
    reformatDate (date) {
      let dateCutted = date.slice(0, 10)
      return dateCutted
        .split('-')
        .reverse()
        .join('/')
    }
  },
  computed: {
    ...mapGetters(['notifications'])
  },
  watch: {
    isModalOpen: function (newVal) {
      this.loadOrderForEdit()
    }
  }
}
</script>

<style lang="scss">
@import "../../../../static/stylesheets/mixins";

.comunication-edit {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .radio {
    &__container {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;

      p {
        margin: auto 0 !important;
        font-size: 16px;
        color: #303030;
      }

      .md-radio {
        margin: auto 0 auto 3.5em;

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-bottom: 10px;
          letter-spacing: 0.8px;
        }
      }
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      background-color: white;
      border: 2px solid white;
    }

    .md-theme-default.md-radio .md-radio-container::after {
      background-color: #7f1a54;
    }
  }

  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    border-radius: 6px;

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .required-fields-label {
        position: absolute;
        right: 5px;
        top: -30px;
        font-size: 12px;
        color: #a80009;
      }

      .tab-label-notification {
        position: absolute;
        right: 180px;
        top: -30px;
        font-size: 12px;
        color: #000;

        strong {
          font-weight: 700;
        }
      }

      .md-layout {
        .md-input-container {
          margin: 0 0 17px;
        }
      }

      .md-input-container,
      .md-input-container.md-input-focused {
        .md-icon {
          color: #c2c2c2;
        }
      }
    }
  }

  .comunication-edit__patient {
    margin-top: 150px;

    .form-container {
      .md-gutter-24:not(.md-column) {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }
}

#cboNotificationTypeEdit {
  label {
    font-size: 12px;
    color: #858585;
    top: 0px;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  100% {
    display: none;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media all and (max-width: 1024px) {
  .comunication-edit__patient .card-form__container .submit-button {
    right: 19px;
  }
}

.IE-11 {
  .inputidlab {
    min-width: 30%;
    max-width: 35%;
  }
}

.title-padding-top {
  padding-top: 40px;
  padding-bottom: 40px;
}

.comunication-edit-mandatory {
  position: absolute;
  right: 5px;
  font-size: 12px;
  color: #a80009;
}
</style>
